import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, List, ListItem, Paper, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import PostListItem from '../../DesignSystem/PostListItem/PostListItem';
import PostCardSkeleton from '../../DesignSystem/PostCard/PostCardSkeleton';
import ButtonLoadMore from '../../Posts/ButtonLoadMore';

function ListItems({
  trackingProps,
  emptyState,
  fetchNextPage,
  hasNextPage,
  hideButtons,
  isFetching,
  newTab,
  pages,
  paging,
  postsCount,
  showEmptyState,
  showSkeleton,
  space,
  titleI18nKey,
  titleProps,
  hideParentLink = false,
  disablePadding = false,
}: any) {
  return (
    <>
      {titleI18nKey && (
        <Box sx={{ mb: 4 }}>
          <Typography component="h2" variant="h4" align="center" {...titleProps}>
            <FormattedMessage
              id={titleI18nKey}
              values={{ count: showSkeleton ? '#' : postsCount }}
            />
          </Typography>
        </Box>
      )}

      {showSkeleton &&
        [0, 1, 2].map((i) => (
          <Box key={i}>
            <PostCardSkeleton noMedia />
          </Box>
        ))}

      {showEmptyState && <Box sx={{ mb: 3 }}>{emptyState}</Box>}

      {!showSkeleton && !showEmptyState && (
        <Paper>
          <List disablePadding={disablePadding}>
            {pages.map(({ data }: any) => (
              <Fragment key={data.paging.page}>
                {data.data.map((post: any) => (
                  <Fragment key={post.id}>
                    <ListItem disableGutters>
                      <PostListItem
                        trackingProps={trackingProps}
                        post={post}
                        space={space}
                        parent={post.included.source}
                        currentStep={post.included.source?.current_step}
                        parentLink={!hideParentLink}
                        hideButtons={hideButtons}
                        newTab={newTab}
                      />
                    </ListItem>
                    <Divider />
                  </Fragment>
                ))}
              </Fragment>
            ))}
          </List>

          {hasNextPage && (
            <Box sx={{ pt: 2, pb: 3 }}>
              <ButtonLoadMore
                onClick={() => fetchNextPage()}
                paging={paging}
                isFetching={isFetching}
                variant="text"
                y
              />
            </Box>
          )}
        </Paper>
      )}
    </>
  );
}
ListItems.propTypes = {
  analyticsTitle: PropTypes.string.isRequired,
  space: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  titleI18nKey: PropTypes.string,
  emptyState: PropTypes.node,
  newTab: PropTypes.bool,
  queryOptions: PropTypes.shape({
    authorId: PropTypes.number,
    visibilities: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default ListItems;
